// extracted by mini-css-extract-plugin
export default {"productCarousel":"g2-z"};